import Simple from '@/services/builder/Simple'
import Teaser, { SEPARATOR_POSITIONS } from '@/services/builder/Teaser'
import { IMAGE_DIMENSIONS } from '@/components/Image/Image'
import { CONSTRAINTS } from '@/services/helper/Constraints'

/**
 * data class for a channel element
 * @param channelData the data retrieved from the backend
 * @param options configurable fields in the channel {}
 */
export default class Channel {
  constructor (channelData, options = {}) {
    this.navigation = channelData.navigation
    this.meta = channelData.meta

    this.elements = channelData.elements.map((element, index) => {
      switch (element.type) {
        case 'ad': {
          const adAttributes = {
            type: 'hp-ad',
            tagId: element.tagid
          }

          if (element.trComponentPath) {
            adAttributes.trComponentPath = element.trComponentPath
          }

          return adAttributes
        }
        case 'teaser': {
          const teaserOptions = {}
          if (channelData.meta.layoutName.includes('Big') && index === 0) {
            teaserOptions.width = IMAGE_DIMENSIONS.teaserBig.width
            teaserOptions.height = IMAGE_DIMENSIONS.teaserBig.height
          }
          return new Teaser(element, teaserOptions)
        }
        case 'simple': {
          return new Simple(element, options)
        }
        case 'slider':
          return {
            type: 'hp-slider',
            interval: element.interval,
            animationType: element.animationType,
            showArrows: !!element.showArrows,
            showIndicators: !!element.showIndicators,
            indicatorPosition: element.indicatorPosition,
            trComponentPath: element.trComponentPath,
            elements: element.elements.map((sliderElement) => {
              switch (sliderElement.type) {
                case 'teaser': {
                  const teaserOptions = {
                    articleoverlay: CONSTRAINTS.channels[channelData.meta.name]?.slider?.teaser?.articleoverlay || false,
                    hideImageIcon: CONSTRAINTS.channels[channelData.meta.name]?.slider?.teaser?.hideImageIcon || false,
                    width: CONSTRAINTS.channels[channelData.meta.name]?.slider?.teaser?.img?.width ?? null,
                    height: CONSTRAINTS.channels[channelData.meta.name]?.slider?.teaser?.img?.height ?? null
                  }
                  return new Teaser(sliderElement, teaserOptions)
                }
                case 'simple':
                  return new Teaser(sliderElement)
                default:
                  return sliderElement
              }
            })
          }
        case 'list': {
          return {
            type: 'hp-list',
            title: element.headline,
            numbered: element.ordered ?? false,
            orientation: 'vertical',
            elements: element.elements.map((listElement) => {
              switch (listElement.type) {
                case 'teaser': // fallthrough
                case 'simple':
                  return new Teaser(listElement, { separator: SEPARATOR_POSITIONS.top })
                default:
                  return listElement
              }
            })
          }
        }
        default:
          return element
      }
    })

    // handling for viewport channel
    if (channelData.meta.name === 'viewport') {
      this.navigation = []
      this.meta.headline = channelData.navigation?.[0]?.title
    }
  }
}
